import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconClipboardList, IconHeartHandshake, IconUsersGroup, IconFolder } from "@tabler/icons-react";
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar } from '../../../redux/slices/uiSlice';
import SidebarOption from './SidebarOption';
import AvatarById from '../../../components/common/AvatarById';
import { getDisplayName } from '../../../utils/userDisplay.js';
import { selectResolvedUserData } from '../../../redux/slices/authSlice';
import { useQueryClient } from '@tanstack/react-query';
import { prefetchProfileTab } from '../../../hooks/queries/profileQueries';
// Comment these out to use modern styles
// import './SidebarOption.css';
// import './Sidebar.css';

// Use this for modern styles
import './Sidebar.css';

const UserProfile = ({ active, onClick, onMouseEnter, onFocus }) => {
  const userData = useSelector(selectResolvedUserData);

  return (
    <div className="sidebar-profile">
      <div
        className={`profile-link ${active ? 'active' : ''}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onFocus={onFocus}
      >
        <div className="avatar-wrapper">
          <AvatarById
            userId={userData?.id || userData?.uid}
            userData={userData}
            fallbackUsername={userData?.displayName || getDisplayName({ profile: userData || null, candidates: [userData?.username, userData?.name] })}
            size="large"
            className="sidebar-avatar"
          />
        </div>
        <div className="sidebar-avatar-info">
          <span className="sidebar-avatar-name">
            {userData?.displayName || getDisplayName({ profile: userData || null, candidates: [userData?.username, userData?.name] })}
          </span>
          {(userData?.userProfession || userData?.profession) && (
            <span className="sidebar-avatar-role">
              {userData?.userProfession || userData?.profession}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const userData = useSelector(selectResolvedUserData);
  const location = useLocation();
  const sidebarOpen = useSelector(state => state.ui.sidebarOpen);

  const isProfileActive = location.pathname === '/profile';

  const handleProfileClick = () => {
    navigate('/profile');
    if (window.innerWidth <= 768) {
      dispatch(toggleSidebar());
    }
  };

  const prefetchMyProfile = () => {
    const uid = userData?.id || userData?.uid;
    if (!uid || !queryClient) return;
    ['posts', 'solutions', 'comments', 'projects'].forEach(tab => prefetchProfileTab(queryClient, tab, uid));
  };

  return (
    <div className={`sidebar-wrapper ${sidebarOpen ? 'open' : ''}`}>
      <div className="sidebar-inner">
        <UserProfile
          active={isProfileActive}
          onClick={handleProfileClick}
          onMouseEnter={prefetchMyProfile}
          onFocus={prefetchMyProfile}
        />

        <div className="sidebar-menu">
          <SidebarOption
            icon={IconHeartHandshake}
            text="Contributions"
            to="/contributions"
            iconColor="green"
          />
          <SidebarOption
            icon={IconUsersGroup}
            text="Followed Projects"
            to="/followed-projects"
            iconColor="#37b2f0"
          />
          <SidebarOption
            icon={IconFolder}
            text="Your Projects"
            to="/your-projects"
            iconColor="red"
          />
          <SidebarOption
            icon={IconClipboardList}
            text="Files"
            to="/files"
            iconColor="#eba834"
          />
        </div>
      </div>
    </div>
  );
}

export default Sidebar;

